import Study from './Study';
import Collection from './ImmutableCollection';

export default class Studies extends Collection(Study)<Study> {}
